// src/encounter/lib/lab-plan-row.ts
// The A&P plan row's detail line for a lab order (PROD-2640, canvas "Lab Panels and Tests",
// artboards 6-8, the plan column).
//
//   a single test         "Whole blood · EDTA"                         (specimen, 6.18)
//   a panel               "Serum · 10 tests · ordered as one panel"     (8.8)
//   a house panel         "Serum · 4 tests"
//
// Where the data allows: the specimen and "ordered as one panel" come from the catalogue v2 panel
// the popup ordered from, and are not on the A&P read, so a reloaded order shows the test count
// alone. No sub-test names and no "Sent to" (both build-only, removed). The order's note keeps its
// place at the end of the line, as before.
import type { CodedOrderPayload } from './order-payload';

type LabPayload = Extract<CodedOrderPayload, { kind: 'lab' }>;

export function labPlanDetail(payload: LabPayload): string | undefined {
  const n = payload.subTests.length;
  const parts = [
    payload.specimen?.trim(),
    n > 0 ? `${n} ${n === 1 ? 'test' : 'tests'}` : undefined,
    n > 0 && payload.orderedAsOnePanel ? 'ordered as one panel' : undefined,
    payload.note,
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : undefined;
}
